<template>
	<div>
		<v-touch v-on:swiperight="onSwipeRight" v-on:swipeleft="onSwipeLeft">
			<FullCalendar
				defaultView="dayGridMonth"
				:plugins="calendarPlugins"
				:locale="locale"
				:events="events"
				:header="header"
				:fixedWeekCount="false"
				:contentHeight="contentHeight"
				@eventClick="eventClick"
				@dateClick="dateClick"
				@eventRender="eventRender"
				@datesRender="datesRender"
				ref="fullCalendar"
				/>
		</v-touch>

		<div class="modal modal-fx-normal" :class="{ 'is-active': isModalActive }">
			<div class="modal-background" @click="onModalBgClick"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">{{ modalDate }}</p>
					<button class="delete" aria-label="close" @click="onModalCloseButtonClick"></button>
				</header>
				<section class="modal-card-body">
					<div class="columns is-mobile">
						<div class="column is-two-fifths">店舗</div>
						<div class="column">{{ modalShopName }}</div>
					</div>
					
					<div class="columns is-mobile">
						<div class="column is-two-fifths">シフト</div>
						<div class="column">{{ modalSchedule }}</div>
					</div>
					
					<div class="columns is-mobile">
						<div class="column is-two-fifths">出退勤</div>
						<div class="column">{{ modalWork }}</div>
					</div>
					
					<div v-if="isAi" class="columns is-mobile">
						<div class="column is-two-fifths">スマイル</div>
						<div class="column"><img class="smile-image" :src="modalSmile" v-if="modalSmile !== ''"></div>
					</div>
					
					<div class="columns is-mobile">
						<div class="column is-two-fifths">シフトメモ</div>
						<div class="column memo">{{ memo }}</div>
					</div>
					
					<div class="columns is-mobile">
						<div class="column is-two-fifths">日報</div>
						<div class="column"></div>
					</div>

					<div class="modal-report">{{ modalReport }}</div>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import momentPlugin from '@fullcalendar/moment'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import jaLocale from '@fullcalendar/core/locales/ja'
import moment from 'moment'
import qs from 'qs'

export default {
	name: 'Dashboard',
	components: {
		FullCalendar,
	},
	data() {
		return {
			calendarPlugins: [ dayGridPlugin, momentPlugin, timeGridPlugin, interactionPlugin ],
			locale: jaLocale,
			events: [],
			header: {
				left: '',
				center: 'title',
				right: 'today prev,next',
			},
			contentHeight: 'auto',
			modalShopName: '',
			modalDate: '',
			modalSchedule: '',
			memo: '',
			modalWork: '',
			modalSmile: '',
			modalReport: '',
			isModalActive: false,
			year: '',
			month: '',
			isAi: false,
		}
	},
	mounted() {
	},
	methods: {
		getData: async function(current) {
			this.$utils.toggleLoading();
			this.$utils.log('getData');
			this.$utils.log(moment(current).format('Y'));// 現在月
			this.$utils.log(moment(current).format('M'));// 現在月

			let data = {
				"year": moment(current).format('Y'),
				"month": moment(current).format('M'),
			};
			this.$utils.log(data);

			let ep = 'works/personal?' + qs.stringify(data);
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.events = res.data.list;
				this.isAi = res.data.is_ai;
				/*
				this.events = [
					{
						event: 'event1',
						date: '2019-07-01',
					},
				];
				*/
			} catch (error) {
				this.$utils.log(error);
				alert(error.response.data.message);
			} finally {
				this.$utils.toggleLoading();
			}
		},
		onSwipeRight: function() {
			//alert('onSwipeRight');
			this.$refs.fullCalendar.getApi().prev();
		},
		onSwipeLeft: function() {
			//alert('onSwipeLeft');
			this.$refs.fullCalendar.getApi().next();
		},
		datesRender: function(info) {
			this.$utils.log('datesRender');
			this.$utils.log(info.view.currentStart);// 現在月
			this.getData(info.view.currentStart);// 現在月
			Array.prototype.slice.call(this.$refs.fullCalendar.$el.getElementsByClassName('fc-day-number')).forEach(day => day.innerHTML = day.innerHTML.replace('日', ''));
		},
		eventRender: function(info) {
			this.$utils.log('eventRender');
			info.el.getElementsByClassName('fc-title')[0].innerHTML = `<img class="fc-smile" src="${info.event.extendedProps.smile}">`;
		},
		dateClick: function(args) {
			this.$utils.log('dateClick');
			this.$utils.log(args);
		},
		eventClick: function(info) {
			this.$utils.log('eventClick');
			this.$utils.log(info.event.extendedProps);
			let prop = info.event.extendedProps;
			this.modalShopName = prop.shop_name;
			this.modalDate = prop.modal_date;
			this.modalSchedule = prop.schedule;
			this.memo = prop.memo;
			this.modalWork = prop.work;
			this.modalSmile = prop.smile.indexOf('check') >= 0 ? '' : prop.smile;
			this.modalReport = prop.report;
			this.isModalActive = true;
		},
		onModalCloseButtonClick: function() {
			this.isModalActive = false;
		},
		onModalBgClick: function() {
			this.isModalActive = false;
		},
	}
}
</script>

<style lang="scss" scoped>
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';

.columns {
	margin-bottom: 0;
}

.modal-card {
	width: 80%;
	border-radius: 5px;

	.modal-card-head {
		height: 15px;
	}

	.modal-card-title {
		font-size: 18px;
	}

	.modal-card-body {
		.modal-report {
			height: 170px;
			overflow: scroll;
			white-space: pre-line;
			word-wrap:break-word;
			border: #ddd 1px solid;
			padding: 5px;
		}

		.smile-image {
			width: 30px;
			height: auto;
		}

		.memo {
			height: 60px;
			overflow: scroll;
		}
	}
}

</style>
